module.exports = __webpack_public_path__ + "img/PL09617.e2f958cb.png";